import api from './api'

export interface Notification {
  id: string
  user_id: string
  type: 'water_quality' | 'feeding' | 'low_stock' | 'harvest' | 'sampling' | 'system' | 'alert'
  priority: 'low' | 'medium' | 'high' | 'critical'
  title: string
  message: string
  is_read: boolean
  related_entity_type?: string
  related_entity_id?: string
  created_at: string
  read_at?: string
}

export interface NotificationStats {
  total: number
  unread: number
  by_type: Record<string, number>
  by_priority: Record<string, number>
}

export const notificationService = {
  async getNotifications(unreadOnly: boolean = false, skip: number = 0, limit: number = 50): Promise<Notification[]> {
    const params = new URLSearchParams()
    params.append('skip', skip.toString())
    params.append('limit', limit.toString())
    if (unreadOnly) {
      params.append('unread_only', 'true')
    }
    
    const response = await api.get<Notification[]>(`/notifications/?${params.toString()}`)
    return response.data
  },

  async getStats(): Promise<NotificationStats> {
    const response = await api.get<NotificationStats>('/notifications/stats')
    return response.data
  },

  async getUnreadCount(): Promise<number> {
    const response = await api.get<{ count: number }>('/notifications/unread-count')
    return response.data.count
  },

  async markAsRead(notificationId: string): Promise<Notification> {
    const response = await api.put<Notification>(`/notifications/${notificationId}/read`)
    return response.data
  },

  async markAllAsRead(): Promise<{ message: string }> {
    const response = await api.post<{ message: string }>('/notifications/mark-all-read')
    return response.data
  },

  async deleteNotification(notificationId: string): Promise<{ message: string }> {
    const response = await api.delete<{ message: string }>(`/notifications/${notificationId}`)
    return response.data
  },

  async deleteOldNotifications(days: number = 30): Promise<{ message: string }> {
    const response = await api.delete<{ message: string }>(`/notifications/old?days=${days}`)
    return response.data
  },

  async createNotification(notification: {
    type: 'water_quality' | 'feeding' | 'low_stock' | 'harvest' | 'sampling' | 'system' | 'alert'
    priority: 'low' | 'medium' | 'high' | 'critical'
    title: string
    message: string
    related_entity_type?: string
    related_entity_id?: string
  }): Promise<Notification> {
    const response = await api.post<Notification>('/notifications/create', notification)
    return response.data
  },

  async createTestNotification(): Promise<Notification> {
    const response = await api.post<Notification>('/notifications/test')
    return response.data
  }
}
